module.exports = __webpack_public_path__ + "static/media/GothamRnd-Light.52ef94ed.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Light.otf
 ** module id = 1351
 ** module chunks = 0
 **/